module.exports = __webpack_public_path__ + "static/img/Grownup.89027471.png";